module.exports = __webpack_public_path__ + "fonts/Myriad-Pro-Light.4e2217c1.otf";